import styled from "@emotion/styled";

export const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.space[5]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    gap: ${p => p.theme.space[6]}px;
  }
`;

export const BoxContainerOne = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
    align-items: center;
    gap: ${p => p.theme.space[0]};
  }
`;

export const BoxContainerTwo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${p => p.theme.space[5]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
    gap: ${p => p.theme.space[6]}px;
  }
`;

export const Title = styled.p`
  font-size: 22px;
  font-weight: ${p => p.theme.fontWeight.medium};
  line-height: 1.25;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 28px;
    line-height: normal;
  }
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  gap: ${p => p.theme.space[4]}px;
`;

export const CheckBoxLabel = styled.p`
  margin-right: ${p => p.theme.space[5]}px;

  font-size: ${p => p.theme.fontSizes.s};
  color: ${({ theme }) => theme.colors.secondary.minor};
  line-height: 1.5;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
    font-weight: ${p => p.theme.fontWeight.medium};
    line-height: normal;
  }
`;
